import jwtDecode from 'jwt-decode';

function mapExpedienteResponse(data) {
  return {
    id: data?.empleadoPuestoId ?? '',
    codigo: data?.empleadoPuestoId ? String(data.empleadoPuestoId) : '',
    tipo_documento: data?.tipoDocumento ?? '',
    nombre_usuario: data?.empleadoNombre ?? '',
    numero_documento: data?.numeroDocumento ?? '',
    foto_empleado: data?.empleadoFoto ?? null,
    pais_nacimiento: data?.paisNacimiento ?? '',
    fecha_nacimiento: data?.fechaNacimiento ?? '',
    telefono_personal: data?.telefonoPersonal ?? '',
    departamento_residencia: data?.departamentoResidencia ?? '',
    distrito_residencia: data?.distritoResidencia ?? '',
    direccion: data?.direccion ?? '',
    email_institucional: data?.emailInstitucional ?? '',
    fecha_contratacion: data?.fechaContratacion ?? '',
    establecimiento: data?.establecimiento ?? '',
    unidad_organizativa: data?.unidadOrganizativa ?? '',
    estado_empleado: data?.estadoEmpleado ?? '',
    fecha_ingreso_gobierno: data?.fechaContratacion || '',
    modalidad_contratacion: data?.modalidadContratacion ?? '',
    tiempo_servicio: data?.tiempoServicio ?? '',
    establecimientoId: data?.establecimientoId ?? 0,
  };
}

export const getUserName = () => {
  const userToken = localStorage.getItem('token');
  const userDecode = jwtDecode(userToken);
  return {
    id_usuario: `${userDecode?.user?.id}`,
    id_establecimiento: userDecode?.puesto?.establecimiento?.id,
  };
}
const formatearArchivos = (archivos) => {
  return Array.isArray(archivos) ? archivos
    : Object.keys(archivos).map(key => archivos[key])
}

export default {
  mapExpedienteResponse,
  formatearArchivos
};
